import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { ReactComponent as BlueRectangle } from "images/background/software-solution-graphic-blue.svg";
import { ReactComponent as RedRectangle } from "images/background/software-solution-graphic-red.svg";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import classes from "./Kiosk.module.css";

const Hero = ({ data, header, clickHandle }) => {
  return (
    <section className={classes.hero}>
      <div className={classes["hero-container"]}>
        <div className={classes.row}>
          <div
            className={`col-lg-6 col-sm-12 ${data.class ? data.class : null}`}
          >
            <div className={classes["text-wrapper"]}>
              <div className={classes["hero-title"]}>
                {data.id % 2 !== 0 ? <BlueRectangle /> : <RedRectangle />}
                <h2>{data.title}</h2>
              </div>
              <p>{data.text}</p>
              <div className={classes["btn-wrapper"]}>
                <Link
                  className={
                    data.id % 2 !== 0
                      ? "green-button"
                      : "accent-button"
                  }
                  to={data.link}
                  clickHandle={clickHandle}
                >
                  <FormattedMessage id={"learn_more"} />
                </Link>
              </div>
            </div>
          </div>
          <div
            className={`col-lg-6 col-sm-12 ${data.class ? data.class : null}`}
          >
            <div className={classes["image-wrapper"]}>
              <img src={data.img} alt="softwareSolution" />
            </div>
            {header ? null : (
              <ul className={data.class ? data.class : null}>
                {data.benefit.map(menu => (
                  <li>
                    <span className={data.id % 2 !== 0 ? "primary" : "accent"}>
                      <FontAwesomeIcon icon={faCheckCircle} />
                    </span>
                    {menu.text}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
